import React, { useContext } from 'react';
import { Paper, Typography, Grid, Box } from '@mui/material';
import HomeInfo from './HomeInfo';
import ChartDia from './homeInfoComponents/ChartDia';

import MoraByGestor from './homeInfoComponents/MoraByGestor';
import ClientsByLocation from './clientComponents/ClientsByLocation';
import CreditsByPeriodicidad from './clientComponents/CreditsByPeriodicidad';
import ColocacionSemanal from './homeInfoComponents/ColocacionSemanal';
import RankingGestores from './clientComponents/RankingGestores';
import FlujoCaja from './homeInfoComponents/FlujoCaja';
import { DataContext } from '../../context/DataContext';
import { isAccess } from '../../helpers/Helpers';

const SectionCard = ({ title, children }) => (
	<Paper sx={{ padding: '20px 22px', height: '100%' }}>
		<Typography sx={{ fontSize: 14, fontWeight: 600, marginBottom: '16px' }}>{title}</Typography>
		{children}
	</Paper>
);

const SectionLabel = ({ children }) => (
	<Typography
		sx={{
			fontSize: 12.5,
			fontWeight: 600,
			color: 'text.secondary',
			letterSpacing: '.2px',
			marginBottom: '10px'
		}}
	>
		{children}
	</Typography>
);

const HomeContainer = () => {
	const { selectedSucursal, access } = useContext(DataContext);

	if (selectedSucursal === 0 || selectedSucursal === undefined) {
		return <></>;
	}

	const showGestores = isAccess(access, 'DASH RANKING GESTORES');

	return (
		<Box sx={{ display: 'flex', flexDirection: 'column', gap: '22px' }}>
			<HomeInfo selectedSucursal={selectedSucursal} />

			<Box>
				<SectionLabel>Cartera</SectionLabel>
				<Grid container spacing={2}>
					<Grid item xs={12} md={6}>
						<SectionCard title="Créditos por periodicidad">
							<CreditsByPeriodicidad selectedSucursal={selectedSucursal} />
						</SectionCard>
					</Grid>

					<Grid item xs={12} md={6}>
						<SectionCard title="Clientes por municipio">
							<ClientsByLocation selectedSucursal={selectedSucursal} />
						</SectionCard>
					</Grid>
				</Grid>
			</Box>

			<Box>
				<SectionLabel>Colocación y flujo de caja</SectionLabel>
				<Grid container spacing={2}>
					{isAccess(access, 'DASH FLUJO CAJA') ? (
						<Grid item xs={12}>
							<SectionCard title="Colocación vs recuperación">
								<FlujoCaja selectedSucursal={selectedSucursal} />
							</SectionCard>
						</Grid>
					) : null}

					<Grid item xs={12}>
						<SectionCard title="Colocación semanal">
							<ColocacionSemanal selectedSucursal={selectedSucursal} />
						</SectionCard>
					</Grid>
				</Grid>
			</Box>

			<Box>
				<SectionLabel>Gestores</SectionLabel>
				<Grid container spacing={2}>
					{showGestores ? (
						<Grid item xs={12}>
							<SectionCard title="Ranking de gestores">
								<RankingGestores selectedSucursal={selectedSucursal} />
							</SectionCard>
						</Grid>
					) : null}

					<Grid item xs={12}>
						<SectionCard title="Recuperación por gestor">
							<ChartDia selectedSucursal={selectedSucursal} />
						</SectionCard>
					</Grid>

					<Grid item xs={12}>
						<SectionCard title="Mora por gestor">
							<MoraByGestor selectedSucursal={selectedSucursal} />
						</SectionCard>
					</Grid>
				</Grid>
			</Box>
		</Box>
	);
};

export default HomeContainer;
